<!-- Link Shopl -->
<template>
  <div class="ls-list-page">
    <!-- =========================
         페이지 헤더
    ========================== -->
    <div class="page-header">
      <div class="page-title-area">
        <h2>근무 인원 집계</h2>
        <p>매장 근무인원 현황</p>
      </div>

      <!-- 매장 선택 -->
      <!-- <div v-if="userInfo && userInfo.OGN_FG === '00'" class="shop-selector">
        <div class="selector-item">
          <span class="selector-label">FC</span>

          <select
            v-model="selectedBranch"
            class="branch-select"
            :disabled="userInfo && userInfo.OGN_FG === '01'"
          >
            <option
              v-for="branch in branchList"
              :key="branch.BRANCH_CD"
              :value="branch.BRANCH_CD"
            >
              {{ branch.BRANCH_NM }}
            </option>
          </select>
        </div>

        <div class="selector-item">
          <span class="selector-label">매장</span>

          <input
            list="team-datalist"
            v-model="teamSearch"
            @change="handleTeamSelection"
            class="team-select"
            placeholder="매장 검색 또는 선택"
            :disabled="userInfo && userInfo.OGN_FG === '01'"
          />

          <datalist id="team-datalist">
            <option
              v-for="team in teamList"
              :key="team.SHOP_CD"
              :value="`(${team.VAN_BIZ_NO}) ${team.SHOP_NM}`"
            />
          </datalist>
        </div>
      </div> -->
      <!-- 사업주 정보 -->
      <div
        v-if="
          userInfo &&
          (userInfo.OGN_FG === '01' ||
            ['TB관리자'].includes(this.userInfo.userId))
        "
        class="owner-info"
      >
        <div class="owner-item">
          <span>점번</span>
          <strong>{{ this.vanBizNo }}</strong>
        </div>

        <div class="owner-item">
          <span>점명</span>
          <strong>{{ this.userInfo.SHOP_NM }}</strong>
        </div>

        <div class="last-updated">
          최종 조회 : <strong>{{ lastUpdated }}</strong>
        </div>

        <button
          type="button"
          class="refresh-btn"
          @click="refreshData"
          :disabled="isLoading"
        >
          <strong>{{ isLoading ? '조회 중...' : '↻ 새로고침' }}</strong>
        </button>

        <!-- <div class="owner-item">
          <span>사업주</span>
          <strong>{{ this.shopMasterNm }}</strong>
        </div> -->
      </div>
    </div>
    <!-- =========================
         그리드 영역
    ========================== -->
    <div class="grid-container">
      <!-- 전체 현황 -->
      <section class="grid-card">
        <div class="grid-card-header">
          <div class="grid-title">
            <span class="grid-title-dot"></span>
            <span>전체 근무 인원 집계</span>
            <p v-if="userInfo && userInfo.OGN_FG === '00'">매장을 클릭하면 근무인원 상세정보를 확인할 수 있습니다.</p>
          </div>

          <span class="grid-count">
            {{ totalRowData ? totalRowData.length : 0 }}건
          </span>
        </div>

        <div class="grid-body">
          <ag-grid-vue
            class="ag-ls-balham"
            :columnDefs="totalColumnDefs"
            :rowData="totalRowData"
            :gridOptions="totalGridOptions"
            :theme="theme"
            @rowClicked="onShopClicked"
          />
        </div>
      </section>

      <!-- 오늘 현황 -->
      <section class="grid-card">
        <div class="grid-card-header">
          <div class="grid-title">
            <span class="grid-title-dot today"></span>
            <span>오늘 근무 인원 집계</span>
          </div>

          <span class="grid-count">
            {{ todayRowData ? todayRowData.length : 0 }}건
          </span>
        </div>

        <div class="grid-body">
          <ag-grid-vue
            class="ag-ls-balham"
            :columnDefs="todayColumnDefs"
            :rowData="todayRowData"
            :gridOptions="todayGridOptions"
            :theme="theme"
          />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import { themeBalham } from "ag-grid-community";
import axios from "axios";

export default {
  components: { AgGridVue },
  name: "BusinessEducation",
  data() {
    const currentYear = new Date().getFullYear();
    return {
      theme: themeBalham.withParams({
        fontFamily: "Malgun Gothic",
        borderColor: "#808080",
        wrapperBorder: true,
        headerRowBorder: true,
        headerColumnBorderHeight: "100%",
        rowBorder: { style: "solid", width: 1 },
        columnBorder: { style: "solid", width: 1 },
      }),

      selectedBranch: "", // 선택된 본부
      branchList: [],
      selectedTeam: "", // 선택된 팀
      teamList: [], // 팀 목록
      teamSearch: "", // 매장 검색용
      userInfo: null, // 로그인한 사용자 정보

      currentYear,

      vanBizNo: "",
      shopMasterNm: "",

      lastUpdated: "-",
      isLoading: false,

      totalRowData: [],
      totalColumnDefs: [
        {
          headerName: "",
          valueGetter: "node.rowIndex + 1",
          width: 45,
          minWidth: 40,
          maxWidth: 50,
          sortable: false,
          resizable: false,
        },
        {
          headerName: "매장 코드",
          field: "SHOP_CD",
          hide: true,
        },
        {
          headerName: "사업장 코드",
          field: "WORKPLACE_CODE",
          hide: true,
        },
        {
          headerName: "매장명",
          field: "WORKPLACE_NAME",
          flex: 2,
          minWidth: 120,
        },
        {
          headerName: "근무월",
          field: "WORK_MONTH",
          flex: 1,
          minWidth: 80,
        },
        {
          headerName: "TO 수",
          field: "TO_CNT",
          flex: 1,
          minWidth: 65,
        },
        {
          headerName: "등록 인원",
          field: "REGISTERED_CNT",
          flex: 1,
          minWidth: 80,
        },
        {
          headerName: "충족 일수",
          field: "FULFILLED_DAYS",
          flex: 1,
          minWidth: 80,
        },
        {
          headerName: "평가 일수",
          field: "GRADED_DAYS",
          flex: 1,
          minWidth: 80,
        },
      ],

      totalGridOptions: {
        headerHeight: 30,
        rowSelection: "single",
        rowHeight: 30,
        defaultColDef: {
          resizable: true,
          cellStyle: { textAlign: "center" },
          headerStyle: {
            backgroundColor: "#ffffc0",
            color: "black",
          },
        },
      },

      todayRowData: [],
      todayColumnDefs: [
        {
          headerName: "시간",
          field: "time",
          flex: 1,
          minWidth: 70,
        },
        {
          headerName: "응답 인원",
          field: "respondedCount",
          flex: 1,
          minWidth: 80,
        },
        {
          headerName: "필요 인원",
          field: "required",
          flex: 1,
          minWidth: 80,
        },
        {
          headerName: "상태",
          field: "status",
          flex: 1.2,
          minWidth: 90,
          valueFormatter: (params) => {
            switch (params.value) {
              case "counted":
                return "집계 완료";

              case "upcoming":
                return "예정";

              default:
                return params.value;
            }
          },
        },
        {
          headerName: "충족 여부",
          field: "ok",
          flex: 1,
          minWidth: 80,
          cellStyle: params => {
            if (params.value) {
              return { backgroundColor: "#5dff6d" };
            } else {
              return { color: "#999" };
            }
          }
        },
      ],
      todayGridOptions: {
        headerHeight: 30,
        rowHeight: 30,
        defaultColDef: {
          resizable: true,
          cellStyle: { textAlign: "center" },
          headerStyle: {
            backgroundColor: "#ffffc0",
            color: "black",
          },
        },
      },  

    };
  },

  mounted() {
    // localStorage에서 사용자 정보 불러오기
    const userInfoString = localStorage.getItem("userInfo");
    if (userInfoString) {
      this.userInfo = JSON.parse(userInfoString);
    }

    // this.fetchCenterList();
    if (this.userInfo?.OGN_FG === "01") {
      // 본부 선택 없이도 바로 팀 목록 불러오기
      this.fetchTeamList("00").then(() => {
        const matched = this.teamList.find(
          (item) => item.SHOP_CD === this.userInfo.SHOP_CD,
        );

        // 찾은 항목이 있으면 그 안의 VAN_BIZ_NO를 formData에 세팅
        if (matched) {
          this.vanBizNo = matched.VAN_BIZ_NO;
        }
         this.loadData(this.userInfo.SHOP_NM);
        // 조회
        this.fetchTodayShop(this.userInfo.SHOP_NM);
        // 데이터 조회
      });
    } else{
      this.loadData();
    }
    this.lastUpdated = this.formatDateTime(new Date());
  },

  watch: {
    selectedBranch(newBranchCd) {
      // 본부가 선택되면 팀 목록을 불러옵니다.
      if (newBranchCd) {
        this.fetchTeamList(newBranchCd).then(() => {
          // 사용자가 직접 본부를 변경했을 때만 매장 선택을 초기화
          if (this.userInfo.OGN_FG === "00") {
            this.selectedTeam = "";
          }
        });
      } else {
        this.teamList = [];
        this.selectedTeam = "";
      }
    },
    selectedTeam(newShopCd) {
      if (newShopCd && newShopCd !== "00") {
        const team = this.teamList.find((t) => t.SHOP_CD === newShopCd);
        if (team) {
          const teamName = `(${team.VAN_BIZ_NO}) ${team.SHOP_NM}`;
          if (this.teamSearch !== teamName) {
            this.teamSearch = teamName;
          }
          if (this.selectedBranch === "전체") {
            this.selectedBranch = team.BRANCH_CD;
          }
          // 선택된 매장으로 랭킹 목록 조회
          // this.fetchShopRankList(newShopCd);
          this.fetchTodayShop(team.SHOP_NM);
        }
      } else {
        if (this.teamSearch !== "") {
          this.teamSearch = "";
        }
      }
    },
  },

  methods: {
    // 매장 선택(datalist 변경) 처리
    handleTeamSelection() {
      const match = this.teamList.find(
        (t) => `(${t.VAN_BIZ_NO}) ${t.SHOP_NM}` === this.teamSearch,
      );
      if (match) {
        this.selectedTeam = match.SHOP_CD;
        // 매장 코드로 데이터 조회
        // this.loadData();
      } else {
        alert("선택한 매장을 찾을 수 없습니다.");
      }
    },

    async fetchCenterList() {
      try {
        const res = await axios.get("/api/lsListPage/centerList");
        this.branchList = res.data;
        if (this.branchList.length > 0) {
          this.selectedBranch = this.branchList[0].BRANCH_CD;
        }
      } catch (error) {
        console.error("본부 목록 로딩 실패:", error);
        alert("본부 목록을 불러오는 데 실패했습니다.");
      }
    },

    async fetchTeamList(branchCd) {
      try {
        const res = await axios.get(
          `/api/lsListPage/teamList?branchCd=${branchCd}`,
        );
        this.teamList = res.data;
      } catch (error) {
        console.error("팀 목록 로딩 실패:", error);
        this.teamList = [];
      }
    },

    async loadData(shopNm) {
      try {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0"); // 01~12
        const currentYearMonth = `${year}${month}`;

        const params = { yearMonth: currentYearMonth };
        if (shopNm) {
          params.shopNm = shopNm;   // shopNm 있으면 같이 넘김
        }
        const res = await axios.get("/api/lsListPage/workplaces", { params },);

        this.totalRowData = res.data;
      } catch (err) {
        console.error("조회 실패:", err);
        alert("샤플 데이터를 불러오는 중 오류가 발생했습니다.");
      }
    },

    async fetchTodayShop(workplaceName) {
      try {
        const res = await axios.get("/api/lsListPage/today", {
          params: { workplaceName: workplaceName },
        });

        // API 응답 구조에서 slots 배열만 뽑아서 rowData에 넣기
        this.todayRowData = res.data.workplaces.flatMap((wp) => wp.slots);
      } catch (err) {
        console.error("조회 실패:", err);
        alert("데이터 조회 중 오류 발생");
      }
    },

    onShopClicked(event) {
      // ag-grid rowClicked 이벤트는 event.data에 행 데이터가 들어있음
      if (this.userInfo?.OGN_FG === '01') {
        return;
      }
      const workplaceName = event.data.WORKPLACE_NAME;

      this.fetchTodayShop(workplaceName);
    },

    formatDateTime(date) {
      const pad = (n) => String(n).padStart(2, "0");

      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
            `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },

    async refreshData() {
      if (this.isLoading) return;

      this.isLoading = true;

      try {
        if (this.userInfo?.OGN_FG === "01") {
            // 조회
            this.loadData(this.userInfo.SHOP_NM);
            // 데이터 조회
            this.fetchTodayShop(this.userInfo.SHOP_NM);
        }
        this.lastUpdated = this.formatDateTime(new Date());
      } catch (error) {
        console.error("데이터 새로고침 실패:", error);
      } finally {
        this.isLoading = false;
      }
    },

  },
};
</script>

<style scoped>
/* =========================================================
   전체
========================================================= */
.ls-list-page {
  height: 90vh;
  min-height: 0;

  padding: 2px;

  background: #f5f7fa;

  box-sizing: border-box;

  font-family: "Malgun Gothic", "Noto Sans KR", Arial, sans-serif;

  color: #1f2937;

  display: flex;
  flex-direction: column;

  overflow: hidden;
}

/* =========================================================
   페이지 헤더
========================================================= */
.page-header {
  flex: 0 0 auto;

  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 10px;

  margin-bottom: 5px;
  padding: 4px 7px;

  background: #ffffff;

  border: 1px solid #e5e7eb;
  border-radius: 12px;

  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);

  box-sizing: border-box;
}

/* 제목 */

.page-title-area {
  min-width: 170px;
}

.page-title-area h2 {
  margin: 3px 0 0;

  color: #111827;

  font-size: 1.05rem;
  font-weight: 700;

  letter-spacing: -0.5px;
}

.page-title-area p {
  margin: 2px 0 0;

  color: #9ca3af;

  font-size: 11px;
}

/* =========================================================
   매장 선택
========================================================= */
.shop-selector {
  display: flex;
  align-items: center;

  gap: 12px;

  margin-left: auto;
}

.selector-item {
  display: flex;
  align-items: center;

  gap: 6px;
}

.selector-label {
  color: #64748b;

  font-size: 0.78rem;
  font-weight: 600;
}

.branch-select,
.team-select {
  height: 29px;

  padding: 0 9px;

  background: #ffffff;

  border: 1px solid #d1d5db;
  border-radius: 7px;

  outline: none;

  color: #374151;

  font-family: inherit;
  font-size: 0.78rem;

  box-sizing: border-box;

  transition: 0.2s;
}

.branch-select {
  min-width: 105px;
}

.team-select {
  width: 205px;
}

.branch-select:focus,
.team-select:focus {
  border-color: #3b82f6;

  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);
}

.branch-select:disabled,
.team-select:disabled {
  background: #f8fafc;
  color: #94a3b8;

  cursor: not-allowed;
}

.team-select::placeholder {
  color: #b6bec9;
}

/* =========================================================
   사업주 정보
========================================================= */
.owner-info {
  display: flex;

  align-items: center;

  gap: 6px;

  margin-left: auto;
}

.owner-item {
  display: flex;
  align-items: center;

  gap: 5px;

  padding: 7px 9px;

  background: #f8fafc;

  border: 1px solid #e5e7eb;

  border-radius: 7px;
}

.owner-item span {
  color: #94a3b8;

  font-size: 0.76rem;
}

.owner-item strong, 
.last-updated strong,
.efresh-btn strong {
  color: #374151;

  font-size: 0.78rem;
}

.last-updated {
  color: #9ca3af;
  font-size: 11px;
  white-space: nowrap;
}

.refresh-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  height: 28px;
  padding: 0 9px;

  border: 1px solid #d1d5db;
  border-radius: 5px;

  background: #fff;
  color: #4b5563;

  font-size: 11px;
  cursor: pointer;
}

.refresh-btn:hover {
  background: #f3f4f6;
}

.refresh-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

/* =========================================================
   그리드 전체 영역
========================================================= */
.grid-container {
  flex: 1 1 auto;

  min-height: 0;

  display: grid;

  grid-template-columns: repeat(2, minmax(0, 1fr));

  gap: 6px;

  overflow: hidden;
}

/* =========================================================
   그리드 카드
========================================================= */
.grid-card {
  min-width: 0;
  min-height: 0;

  display: flex;
  flex-direction: column;

  background: #ffffff;

  border: 1px solid #e2e6eb;

  border-radius: 10px;

  overflow: hidden;

  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
}

/* =========================================================
   그리드 제목
========================================================= */
.grid-card-header {
  flex: 0 0 36px;

  display: flex;

  align-items: center;

  justify-content: space-between;

  padding: 0 11px;

  background: #fafbfc;

  border-bottom: 1px solid #e5e7eb;

  box-sizing: border-box;
}

.grid-title {
  display: flex;

  align-items: center;

  gap: 7px;

  color: #374151;

  font-size: 0.82rem;

  font-weight: 700;
}

.grid-title-dot {
  width: 7px;
  height: 7px;

  border-radius: 50%;

  background: #64748b;

  flex-shrink: 0;
}

.grid-title p {
  margin: 2px 0 0;

  color: #9ca3af;

  font-size: 11px;
}

.grid-title-dot.today {
  background: #3b82f6;
}

.grid-count {
  padding: 2px 7px;

  background: #f1f5f9;

  border-radius: 10px;

  color: #64748b;

  font-size: 0.7rem;

  font-weight: 600;
}

/* =========================================================
   Grid Body
========================================================= */
.grid-body {
  flex: 1 1 auto;

  min-height: 0;

  position: relative;
}

/* =========================================================
   AG Grid
========================================================= */
:deep(.ag-ls-balham) {
  width: 100%;
  height: 100%;

  --ag-cell-horizontal-padding: 5px;
  --ag-cell-vertical-padding: 2px;

  --ag-border-color: #e5e7eb;

  --ag-row-border-color: #eef0f3;

  --ag-header-background-color: #f8fafc;

  --ag-header-foreground-color: #374151;

  --ag-font-family: "Malgun Gothic", "Noto Sans KR", Arial, sans-serif;

  border: none;

  border-radius: 0;

  overflow: hidden;
}

/* Grid 헤더 */
:deep(.ag-ls-balham .ag-header) {
  border-bottom: 1px solid #dfe3e8;
}

:deep(.ag-ls-balham .ag-header-cell-comp-wrapper) {
  display: flex;

  align-items: center;
  justify-content: center;

  height: 100%;
}

:deep(.ag-ls-balham .ag-header-cell-label) {
  justify-content: center !important;

  align-items: center !important;

  white-space: pre-line;

  color: #374151;

  font-size: 0.78rem;

  font-weight: 600;
}

/* Grid 셀 */
:deep(.ag-ls-balham .ag-cell) {
  display: flex;

  justify-content: center !important;

  align-items: center;

  font-size: 0.78rem;

  color: #374151;
}

/* 마우스 오버 */
:deep(.ag-ls-balham .ag-row-hover .ag-cell) {
  background: #f8fafc;
}

/* 선택된 행 */
:deep(.ag-ls-balham .ag-row-selected .ag-cell) {
  background: #ffff00 !important;
}

/* 선택된 행 hover */
:deep(.ag-ls-balham .ag-row-selected.ag-row-hover .ag-cell) {
  background: #ffef9c !important;
}

/* 체크박스 크기 */
:deep(.ag-ls-balham .ag-checkbox-input-wrapper) {
  transform: scale(1.15);
}

/* =========================================================
   반응형
========================================================= */

/* 화면이 좁아지면 위/아래 배치 */
@media (max-width: 1024px) {
  .grid-container {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
}

/* 태블릿 / 작은 화면 */
@media (max-width: 700px) {
  .page-header {
    flex-wrap: wrap;

    padding: 5px;
  }

  .page-title-area {
    min-width: auto;
  }

  .shop-selector {
    width: 100%;

    margin-left: 0;

    justify-content: flex-end;
  }

  .owner-info {
    width: 100%;

    margin-left: 0;

    justify-content: flex-end;
  }

  .team-select {
    width: 180px;
  }

  .grid-card-header {
    flex-basis: 32px;
  }
}

/* 아주 작은 화면 */
@media (max-width: 500px) {
  .shop-selector {
    flex-wrap: wrap;

    justify-content: flex-start;
  }

  .owner-info {
    flex-wrap: wrap;

    justify-content: flex-start;
  }

  .team-select {
    width: 160px;
  }
}
</style>
